import React, { useEffect, useRef, useState } from "react";
import NotesForm from "./NotesForm";
import { useTranslation } from "react-i18next";
import NotesParent from "./NotesParent";
import { useForm } from "react-hook-form";
import NotesFilter from "./NotesFilter";
import { useDispatch, useSelector } from "react-redux";
import { authLoginSelector } from "../../../features/auth/authLoginSlice";
import { formatDate } from "../../../common/utils";
import SorterNotes from "../Sorter/SorterNotes";
import {
  GetAllNotes,
  GetAllNotificationsForUser,
  getCategoryDetails,
  notesSliceSelector,
  saveNote,
} from "../../../features/notes/notesSlice";
import { languageSelector } from "../../../features/language/languageSlice";

function searchNotes(notes, searchTerm, parentNote = null) {
  const filteredNotes = [];

  for (const note of notes) {
    const isFound =
      note.note.toLowerCase().includes(searchTerm.toLowerCase()) ||
      note.standardNoteText.toLowerCase().includes(searchTerm.toLowerCase());
    if (isFound) {
      const isParentNote = parentNote
        ? filteredNotes.some((n) => n.noteID === parentNote.noteID)
        : false;
      if (!isParentNote) {
        filteredNotes.push(parentNote ? parentNote : note);
      }
    }

    if (!isFound && note.childNotes && note.childNotes.length > 0) {
      const matchingChildren = searchNotes(note.childNotes, searchTerm, note);
      filteredNotes.push(...matchingChildren);
    }
  }

  return filteredNotes;
}
function Notes({ id, refs, quotesNotes }) {
  // const [notes, setNotes] = useState([]);
  const {
    handleSubmit,
    register,
    reset,
    setValue,
    getValues,
    trigger,
    control,
    watch,
  } = useForm({
    mode: "onBlur",
    defaultValues: {
      category: "",
      sentBy: "",
      date: null,
    },
  });
  const [search, setSearch] = useState("");
  const [column, setColumn] = useState(null);
  const [order, setOrder] = useState("ascending");
  const [dateFilter, setDateFilter] = useState(watch("date"));

  const { userLogin } = useSelector(authLoginSelector);
  const { notes } = useSelector(notesSliceSelector);
  const lang = useSelector(languageSelector);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(GetAllNotes(parseInt(id) - 100000));
    dispatch(getCategoryDetails(userLogin.userId));
  }, []);
  const notesHistoryRef = useRef(null);

  const addNote = async (description) => {
    dispatch(
      saveNote(
        parseInt(id) - 100000,
        description,
        // category,
        userLogin.userId,
        null,
        null,
        "CTIC",
        true,
        true
      )
    );
    // setNotes((prev) => [
    //   ...prev,
    //   {
    //     category,
    //     description,
    //     id: prev.length + 1,
    //     section: category,
    //     time: new Date(),
    //     name: userLogin.firstName + ' ' + userLogin.lastName,
    //     childNotes: [],
    //   },
    // ]);
  };

  const isInternalNote = (str) => {
    const match = str.match(/IsAddedByInternalUser#(true|false)/);
    return match ? match[1] === "true" : null;
  };
  const filteredNotes = search ? searchNotes(notes, search) : [...notes];
  const dropdownChange = (e, name) => {
    setValue(name, e);
    trigger(name);
  };
  const categoryValue = watch("category");
  const sentBy = watch("sentBy");

  const filterAppliedNotes = filteredNotes.filter((item) => {
    const date = new Date(item.createDate);
    const filterDate = dateFilter ? new Date(`${dateFilter}T00:00:00`) : null;
    // Check if category filter is empty or matches the object's category

    const namePass = !sentBy || item.userName.includes(sentBy);
    // Check if date filter is empty or the object's date is greater than or equal to the filter date
    const datePass =
      !filterDate ||
      (date?.getFullYear() === filterDate?.getFullYear() &&
        date?.getMonth() === filterDate?.getMonth() &&
        date?.getDate() === filterDate?.getDate());

    return namePass && datePass;
  });
  const handleSort = (column, sortOrder) => {
    setColumn(column);
    setOrder(sortOrder);
  };

  return (
    <div
      id="notes"
      className={!quotesNotes && "border border-[#A09F9F] mb-[10px] mt-[32px] rounded"}
      style={quotesNotes ? {width: "1055px"} : {}}
      ref={el => refs && refs.current && (refs.current[2] = el)}
    >
      <NotesForm t={t} addNote={addNote} quotesNotes={quotesNotes}/>
      <div
        className="bg-white border border-l border-r rounded"
        id="notes-history"
      >
        <div className="flex flex-row justify-between">
          <h2 className="font-[700] font-montserrat leading-[26.82px] pl-[40px] pt-[32px] text-[22px]">
            {t("noteHistory")}
          </h2>
          <NotesFilter
            search={search}
            setSearch={setSearch}
            categoryValue={categoryValue}
            sentBy={sentBy}
            dateFilter={dateFilter}
            setDateFilter={setDateFilter}
            control={control}
            dropdownChange={dropdownChange}
            reset={reset}
            register={register}
            handleSubmit={handleSubmit}
            t={t}
          />
        </div>
        <div className="break-all pt-[24px]">
          <div className="relative">
            <SorterNotes t={t} onSort={handleSort} />
            <div
              className="border-[#A09F9F] font-[400] font-open-sans h-[490px] overflow-y-auto text-[16px]"
              id="notes_history_table_body"
            >
              {notes.length > 0 &&
                filteredNotes.length > 0 &&
                filterAppliedNotes.length > 0 ? (
                filterAppliedNotes
                  .sort((a, b) => {
                    if (column) {
                      if (column === "createDate") {
                        const dateA = new Date(a[column]);
                        const dateB = new Date(b[column]);
                        if (order === "ascending") {
                          return dateA - dateB;
                        } else {
                          return dateB - dateA;
                        }
                      } else if (column === "isImportant") {
                        if (order === "ascending")
                          return b.isImportant - a.isImportant;
                        else return a.isImportant - b.isImportant;
                      } else {
                        if (order === "ascending") {
                          return a[column].localeCompare(b[column]);
                        } else {
                          return b[column].localeCompare(a[column]);
                        }
                      }
                    }
                    return true;
                  })
                  .map((item, index) => (
                    <NotesParent
                      section={
                        lang === "fr"
                          ? item.standardNoteTextFr
                          : item.standardNoteText
                      }
                      description={item.note}
                      key={index}
                      childNotes={item.childNotes}
                      time={item.createDate}
                      name={item.userName}
                      notes={notes}
                      ID={item.noteID}
                      userLogin={userLogin}
                      t={t}
                      id={id}
                      userId={userLogin.userId}
                      lang={lang}
                      standardNoteID={item?.standardNoteID}
                      important={item.isImportant}
                      threadID={item.threadID}
                      submittedPlatform={item.submittedPlatform}
                      isAddedByInternalUser={isInternalNote(item.noteDetails)}
                    />
                  ))
              ) : (
                <div className="flex justify-center items-center h-64 my-10">
                  {" "}
                  <p className="text-center text-red-500 font-bold">
                    {t("NoResults")}
                  </p>
                </div>
              )}
            </div>
            <div className="absolute bg-white bottom-0 h-1 w-full"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(Notes);
